



















































import Vue from 'vue';
import { CloseFullscreenWrapper, TriggerRefreshError } from '@/mixins';
import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { ExtendMixins } from '@/services';
import { MemberBankAccountResponseModel } from '@/@types/member';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  refreshError: boolean;
  confirmBeforeClose: boolean;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  TriggerRefreshError,
).extend({
  name: 'MakePrimaryBankAccount',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      refreshError: false,
      confirmBeforeClose: false,
    };
  },
  computed: {
    bankAccounts(): MemberBankAccountResponseModel[] {
      return this.$store.getters.bankAccounts;
    },
    currentBankAccount(): MemberBankAccountResponseModel {
      const filteredBankAccounts = this.bankAccounts.filter((bankAccount) => {
        return (
          bankAccount.id.toString() === this.params.bankKey.toString()
        );
      });
      return filteredBankAccounts.length ? filteredBankAccounts[0] : null;
    },
    primaryBankAccount(): MemberBankAccountResponseModel {
      return this.$store.getters.primaryBankAccount;
    },
    contentCallout(): string {
      return `${
        this.currentBankAccount.name
      } (…${this.$options.filters.last4Digits(
        this.currentBankAccount.accountNumber,
      )})`;
    },
  },
  methods: {
    updateBankAccount(): void {
      if (this.primaryBankAccount) {
        this.changePrimaryBankAccount();
      } else {
        this.changeCurrentBankAccount();
      }
    },
    changePrimaryBankAccount(): void {
      const payload = {
        bankKey: this.primaryBankAccount.id,
        isTerminated: false,
        useForClaims: false,
        useForContributions: true,
      };
      this.isLoading = true;
      this.$store
        .dispatch('updateBankAccount', payload)
        .then(() => {
          this.changeCurrentBankAccount();
        })
        .catch(() => {
          this.confirmBeforeClose = false;
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'make-primary-bank-account_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
    changeCurrentBankAccount(): void {
      const payload = {
        bankKey: this.currentBankAccount.id,
        isTerminated: false,
        useForClaims: true,
        useForContributions: true,
      };
      this.isLoading = true;
      this.$store
        .dispatch('updateBankAccount', payload)
        .then(() => {
          this.refreshBankingInformation();
        })
        .catch(() => {
          this.confirmBeforeClose = false;
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    refreshBankingInformation(): void {
      this.$store
        .dispatch('getBankingInformation')
        .then(() => {
          this.confirmBeforeClose = false;
          this.showSuccessMessage = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.confirmBeforeClose = false;
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'make-primary-bank-account_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
